import { getServerUrl } from "@/lib/runtime-config";
import { useQuery } from "@tanstack/react-query";
import { useAtom } from "@xoid/react";
import { atom } from "xoid";

export const forceOffline = atom<boolean>(
  localStorage.getItem("isOffline") === "true",
);

export function updateForceOffline(value: boolean) {
  localStorage.setItem("isOffline", value.toString());
  forceOffline.set(value);
}

export function useNetworkStatus() {
  const forceOfflineValue = useAtom(forceOffline);

  return useQuery({
    queryKey: ["network-status", forceOfflineValue],
    refetchOnMount: true,
    refetchInterval: 30000,
    queryFn: async () => {
      if (localStorage.getItem("isOffline") === "true") {
        return "disconnected" as const;
      }
      const serverUrl = getServerUrl();
      try {
        const timeout = setTimeout(() => {
          throw new Error(`backend server down (${serverUrl})`);
        }, 5000);
        const response = await fetch(
          `${serverUrl}/check-application-version`,
        );
        clearTimeout(timeout);
        if (response.ok) {
          return "connected" as const;
        } else {
          return "disconnected" as const;
        }
      } catch (err) {
        return "disconnected" as const;
      }
    },
  });
}
